import { render } from "./GmailEmailSummary.vue?vue&type=template&id=70c8f202"
import script from "./GmailEmailSummary.vue?vue&type=script&lang=js"
export * from "./GmailEmailSummary.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__